import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-10" }

import Icon from "@/components/Icons/Icon.vue";
import MedicalAlertForm from "@/views/ClientComponents/MedicalAlerts/Partials/MedicalAlertForm.vue";
import {computed, onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import CreatedBy from "@/components/custom/CreatedBy.vue";
import ButtonFixed from "@/components/custom/ButtonFixed.vue";
import moment from "moment/moment";
import {medicalAlertsService} from "@/api/services/medicalAlerts";
import {useSettingsStore} from "@/api/store/settings";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateEditMedicalAlerts',
  setup(__props) {

const settingsStore = useSettingsStore();
const router = useRouter();
const route = useRoute();

const errors = ref(null);
const loading = ref(false);

const formState = ref({
  name: '',
  description: '',
  type: 'Intolerance',
  date_from: moment().format('YYYY-MM-DD'),
  status: 'Ongoing',
  method: 'date',
  date_to: moment().format('YYYY-MM-DD'),
  client_visibility: true,
});

const disableSave = computed(() => {
  return !formState.value.name || !formState.value.description
})

const onSave = () => {
  loading.value = true;

  if (route.params.action === 'edit') {
    medicalAlertsService.update(route.params.id, formState.value).then(() => {
      loading.value = false;
      router.push({name: 'medical-alerts'})
    }).catch((error) => {
      errors.value = error.response.data.errors
      loading.value = false;
    });
  } else {
    medicalAlertsService.create(formState.value).then(() => {
      loading.value = false;
      router.push({name: 'medical-alerts'})
    }).catch((error) => {
      errors.value = error.response.data.errors
      loading.value = false;
    });
  }
}

const fetchMedicalAlert = () => {
  if (route.params.action === 'edit') {
    

    medicalAlertsService.show(route.params.id).then(({data}) => {
      formState.value = {
        name: data.name,
        description: data.description,
        type: data.type,
        date_from: data.date_from,
        status: data.status,
        method: data.method,
        date_to: data.date_to,
      }

      
    })
  }
}

onMounted(fetchMedicalAlert)

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, { class: "px-0 pt-0 pb-5" }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "text-right px-4 pt-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'medical-alerts' })))
        }, [
          _createVNode(Icon, {
            color: "primaryColor",
            icon: "cross-icon"
          })
        ]),
        _createElementVNode("section", _hoisted_1, [
          _createVNode(CreatedBy),
          _createVNode(MedicalAlertForm, {
            modelValue: formState.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState).value = $event)),
            errors: errors.value
          }, null, 8, ["modelValue", "errors"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", null, [
      _createVNode(ButtonFixed, {
        "custom-class": ['text-white', {
          'primary-button': !disableSave.value,
          'grey-disable': disableSave.value || loading.value
        }],
        "custom-icon-class": "add-new-circle-icon",
        text: "Save",
        onClick: onSave
      }, null, 8, ["custom-class"])
    ])
  ], 64))
}
}

})